module.exports = __webpack_public_path__ + "img/3.360e71c9.png";